module.exports = __webpack_public_path__ + "bouncer-fb14d3ca8cfb717a48f5.jpg";